import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from './service/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy  {
  constructor(
    private translate: TranslateService,
    private router: Router,
    public spinnerService: SpinnerService) {

    this.translate.setDefaultLang('sv');
    this.translate.use(environment.language);
    
    if (!environment.production) {
      this.router.navigate(['', environment.testClinicId]);      
    }
  }
  ngOnInit() {
    document.addEventListener('dblclick', this.preventGlobalZoom, false);
  }

  ngOnDestroy() {
    document.removeEventListener('dblclick', this.preventGlobalZoom, false);
  }
  preventGlobalZoom = (event: MouseEvent) => {
    event.preventDefault();
  }
}
